<template>
  <svg v-if="step === 'one'" width="480" height="69" viewBox="0 0 480 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="33" y="17.5" width="405" height="2" fill="white" fill-opacity="0.8"/>
    <circle cx="447" cy="18.5" r="9" fill="white" fill-opacity="0.8"/>
    <text fill="#ffffff99" x="410" y="63" >
      {{ $t('register.activation') }}
    </text>
    <circle cx="31" cy="18.5" r="12.5" fill="white" stroke="#D51F27" stroke-width="11"/>
    <text fill="#ffffff" x="0" y="63" >
      {{ $t('register.account') }}
    </text>
  </svg>

  <svg v-else width="480" height="69" viewBox="0 0 480 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="39" y="17.5" width="398" height="2" fill="#D51F27"/>
    <text fill="#ffffff" x="410" y="63" >
      {{ $t('register.activation') }}
    </text>
    <circle cx="447" cy="18.5" r="12.5" fill="white" stroke="#D51F27" stroke-width="11"/>
    <circle cx="30.5" cy="18.5" r="9" fill="#D51F27"/>
    <text fill="#ffffff99" x="0" y="63" >
      {{ $t('register.account') }}
    </text>
  </svg>


</template>

<script>
export default {
  name: "steps",
  props:{
    step:{
      type: String,
      default: function(){
        return 'one';
      }
    }
  }
}
</script>

<style scoped>

</style>